export const a11y = {

    init: () => {

        let $navMain = document.querySelector('.nav--main');
        if (!$navMain) return;

        // a11y.skipLinks(); // not relevant
        // a11y.setContentAnchor(); // not relevant?
    },

    skipLinks: () => {
        let $anchors = document.querySelectorAll('.a11y-skip a');
        Array.prototype.forEach.call($anchors, ($anchor, i) => {
            $anchor.addEventListener('click', (e) => {
                e.preventDefault();
                let href = $anchor.hash;
                // console.log(href);
                window.scrollTo({
                    'top': document.querySelector(href).offsetTop,
                    behavior: 'smooth'
                });
            })
        });
    },

    setContentAnchor: () => {
        // set #content to first Section (skip Headers);
        let $sections = document.querySelector('main .page');
        let $firstContent = Array.from($sections.children).filter(node => !node.matches('.home-intro, .page-header'));
        $firstContent[0].id = 'content';
    }
}